import * as Yup from 'yup';

export const validationSchemaPassword = new Yup.ObjectSchema({
    passwordCurrent:Yup.string().required('Cannot be empty').min(6,'Password should be atleast 6 character long'),
    password:Yup.string().required('Cannot be empty').min(6,'Password should be atleast 6 character long'),
    passwordConfirm: Yup.string().required('Cannot be empty').oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

export const initialValuesPassword = {
    passwordCurrent:'',
    passwordConfirm:'',
}

export const feildsPassword = [
    {
        name:'passwordCurrent',
        placeholder:'Enter your current password',
        id:'passwordCurrent',
        type:'password',
        label:'New passwordCurrent'
    },
    {
        name:'password',
        placeholder:'Enter new password',
        id:'password',
        type:'password',
        label:'New Password'
    },
    {
        name:'passwordConfirm',
        placeholder:'Enter password again',
        id:'passwordConfirm',
        type:'password',
        label:'Confirm Password'
    },
];